import { render, staticRenderFns } from "./IndividualProfileStage.vue?vue&type=template&id=53f30b26&scoped=true&"
import script from "./IndividualProfileStage.vue?vue&type=script&lang=js&"
export * from "./IndividualProfileStage.vue?vue&type=script&lang=js&"
import style0 from "./IndividualProfileStage.vue?vue&type=style&index=0&id=53f30b26&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f30b26",
  null
  
)

export default component.exports